document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.contact-lens-custom-forms')) {
    window.addEventListener('pageshow', function(event){


    const areYouExistingCustomer = document.querySelectorAll('input[name="existing-customer-question"]');
    const existingSectionWrapper = document.querySelector('.existing-customer-section');
    const haveAgreedExistingPrescription = document.getElementById('have-file-agreement');
    const existingPhoneNumberOnFile = document.getElementById('existing-telephone');
    let currentValue = document.querySelector('input[name="existing-customer-question"]:checked')?.value;
    let uploadIncluded = false;

    haveAgreedExistingPrescription.checked = false;

    if(document.querySelectorAll('.upload-input')){

    const threemonthbtn = document.getElementById('3-month-option');
    const sixmonthbtn = document.getElementById('6-month-option');
    const twelvemonthbtn = document.getElementById('12-month-option');
    const quickbuybuttons = document.querySelectorAll('.prescription-quick-buy-btn');
    const uploadSection = document.querySelector('#upload_file_section_area');
    const uploadWrapper = document.getElementById('upload_file_section');
    const uploadTextNotice = document.querySelector('#please_upload_text');
    const entireOptionsSection = document.querySelectorAll('.main-section-wrapper');
    const entireOptionsSectionHider = document.querySelectorAll('.whole-section-hider');
    const uploadInstruction = document.getElementById('upload-status');
    const uploadfileInputSection = document.getElementById('upload-file-input-section');
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    const submitBtn = document.getElementById('add-to-cart-btn-prescription');
    const submitBtnWrap = document.getElementById('submit-btn-wrapper');
    const theDisclaimer = document.getElementById('disclaimer');
    const phoneSectionWrapper = document.querySelector('.existing-customer-phone-section');




    //console.log('pageshow fired');

    const fileInputs = document.querySelectorAll('.upload-input');

    const qtyInputs = document.querySelectorAll('#qty-right-normal, #qty-left-normal');

    const qtyButtons = document.querySelectorAll('.qty-plus, .qty-minus');

    quickbuybuttons.forEach(button => {
      button.addEventListener('click', () => {
        quickbuybuttons.forEach(btn => btn.classList.remove('active-btn'));
        button.classList.add('active-btn');
      });
    });

    function clearActiveButtons() {
      quickbuybuttons.forEach(btn => btn.classList.remove('active-btn'));
    }

    qtyInputs.forEach(input => {
      input.addEventListener('change', clearActiveButtons);
    });

    qtyButtons.forEach(button => {
      button.addEventListener('click', clearActiveButtons);
    });

    let notReady = function(){
  
        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.dataset.uploadneed;
        submitBtnWrap.classList.add('disabled');
        quickbuybuttons.forEach(btn =>{
            btn.disabled = true;
            btn.classList.add("disabled");
        });
        entireOptionsSection.forEach(area=>{
          area.classList.add('hider');
        });
  
    }

    let isReady = function(){
        removeErrors();
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.ready;
        submitBtnWrap.classList.remove('disabled');
        quickbuybuttons.forEach(btn =>{
            btn.disabled = false;
            btn.classList.remove("disabled");
        });
        entireOptionsSection.forEach(area=>{
          area.classList.remove('hider');
        });

    }

    let existingCustomerProcessCheck = function (){
      if(haveAgreedExistingPrescription.checked && existingPhoneNumberOnFile.value.trim() !== ''){
        isReady();
      }
      else{
        notReady();
      }
    }

    areYouExistingCustomer.forEach(radio => {
      radio.addEventListener('change', function () {
        if(this.value=="New Patient"){
          existingSectionWrapper.classList.add("hider");
          uploadWrapper.classList.remove("hider");
          submitBtn.textContent = submitBtn.dataset.uploadneed;
          updateButtonState();
        }
        else{
          existingSectionWrapper.classList.remove("hider");
          uploadWrapper.classList.add("hider");
          submitBtn.textContent = submitBtn.dataset.pleaseconfirm;
          existingCustomerProcessCheck();
        }
      });
      radio.addEventListener('click', function(){
        if(this.value == currentValue && uploadIncluded == false){
          whereIsThePrescription();
        }
        else if(this.value == currentValue && uploadIncluded == true){
          console.log("go go go");
          window.smoothScrollTo(radio, '#add-to-cart-btn-prescription',  {duration:1000, offsetRatio:0.5});
        }
        currentValue = this.value;

      });
    });

    haveAgreedExistingPrescription.addEventListener('change', ()=>{
      existingCustomerProcessCheck();
    });

    existingPhoneNumberOnFile.addEventListener("input", ()=>{
      existingCustomerProcessCheck();
    });
    existingPhoneNumberOnFile.addEventListener("change", ()=>{
      existingCustomerProcessCheck();
    });

    if (!fileInputs.length) return;

    fileInputs.forEach((input) => {
      const key = input.id.split('-')[2]; // e.g. "left" or "right"
      const filenameDiv = document.getElementById('filename-' + key);
      const statusDiv = document.getElementById('status-' + key); // if you have a separate status

      if (!filenameDiv) return;

      // Define inputStatus so it can be called on pageshow
      function inputStatus(ele) {
        console.log(ele);

        if (ele.files.length > 0) {
          const fileName = ele.files[0].name;
          filenameDiv.innerHTML = `<span>${fileName}</span>`;
          filenameDiv.classList.add('has-file');
          entireOptionsSection.forEach(area=>{
            area.classList.remove('hider');
          });
          uploadInstruction.innerHTML = uploadInstruction.dataset.readytogo;
          uploadIncluded = true;
          removeErrors();
        } else {
          filenameDiv.innerHTML = `<span>${filenameDiv.dataset.nofile}</span>`;
          filenameDiv.classList.remove('has-file');
          uploadIncluded = false;
          entireOptionsSection.forEach(area=>{
            area.classList.add('hider');
          });
        }
      }

      // Run inputStatus on pageshow
      inputStatus(input);

      // Also run on change
      input.addEventListener('change', function () {
        inputStatus(this);
      });
    });
    function whereIsThePrescription(ele){
        uploadSection.classList.add("error");
        uploadTextNotice.classList.add("error");
        if(!haveAgreedExistingPrescription.checked){
          theDisclaimer.classList.add("error");
        }
        else{
          theDisclaimer.classList.remove("error");
        }
        if(existingPhoneNumberOnFile.value.trim() == ''){
          phoneSectionWrapper.classList.add("error");
        }
        else{
          phoneSectionWrapper.classList.remove("error");
        }
        console.log(uploadSection);
    }

    function removeErrors(ele){
        uploadSection.classList.remove("error");
        uploadTextNotice.classList.remove("error");
        theDisclaimer.classList.remove("error");
        phoneSectionWrapper.classList.remove("error");
    }

    entireOptionsSectionHider.forEach(area=>{
        area.addEventListener("click", function(e) {
        whereIsThePrescription(this);
    });
    });
    
        const statusDiv = document.getElementById('upload-status');
        const fileInput = document.querySelector('.upload-input');
        if (!fileInput) return; // Skip non-prescription forms
        
        // Disable button initially if no file
        function updateButtonState() {
          //console.log(fileInput.files.length);
        if (fileInput.files.length === 0) {
          notReady();
        } else {
          isReady();
        }
        }
        
        // Update on file change
        fileInput.addEventListener('change', updateButtonState);
        
        // Initial state
        updateButtonState();
        //console.log(fileInput);

        /*
        document.addEventListener('cart:update', function (event) {
            statusDiv.innerHTML = statusDiv.dataset.done;
            submitBtn.textContent = submitBtn.dataset.morefiles;
            submitBtn.disabled = false;
        });*/



    }






    });
  }
});